import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

const moduleErrorLog = {
  namespaced: true,

  state: {
    name: 'error-log',

    errors: []
  },

  mutations,
  getters,
  actions
}

export default moduleErrorLog;